export const UPDATE_DRAWER_NAVIGATION_MENU_STATE =
  'UPDATE_DRAWER_NAVIGATION_MENU_STATE'
export const UPDATE_THEME = 'UPDATE_THEME'
export const INITIALIZE_SERVICE_WORKER = 'INITIALIZE_SERVICE_WORKER'
export const UPDATE_SERVICE_WORKER = 'UPDATE_SERVICE_WORKER'
